// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fjBKb {\n  display: none;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--color-red);\n}\n\n._84bIF {\n  position: absolute;\n}\n\n.jpZUf {\n  display: block;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "fjBKb",
	"badgeRoot": "_84bIF",
	"show": "jpZUf"
};
export default ___CSS_LOADER_EXPORT___;
